import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { AppState } from '../../stores/redux-store';
import { LoadingOverlay } from '../../core/screens/LoadingOverlay/LoadingOverlay';
import { CREDENTIALS_STATE_INVALID } from '../../utilities/error';
import { setApplicationError as setApplicationErrorConnect } from '../../stores/app-state-store';
import { buildSingleProviderUrl } from '../../routes';
import { useProduct } from '../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { useVersion } from '../../components/ApplicationProviders/VersionProvider/VersionProvider';
import { ProductDimensionExtendConsent } from '../../models/product';

type ExtendConsentLandingProps = PropsFromRedux;

export const ExtendConsentLandingPresenter: React.FC<ExtendConsentLandingProps> = ({
  userCredentials,
  setApplicationError,
}: ExtendConsentLandingProps) => {
  const {
    version: { version },
  } = useVersion();
  const { productType } = useProduct();
  const credentials = userCredentials[0];

  useEffect(() => {
    if (!credentials) {
      setApplicationError(CREDENTIALS_STATE_INVALID);
    }
  }, [credentials, setApplicationError]);

  if (!credentials) {
    return <LoadingOverlay />;
  }

  const redirectUrl = buildSingleProviderUrl({
    version,
    productType,
    productDimension: ProductDimensionExtendConsent.EXTEND_CONSENT,
    providerName: credentials.providerName,
  });

  return <Redirect to={redirectUrl} />;
};

const mapStateToProps = (state: AppState) => {
  return {
    userCredentials: state.userCredentials.data,
  };
};

const mapDispatchToProps = {
  setApplicationError: setApplicationErrorConnect,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const ExtendConsentLanding = connector(ExtendConsentLandingPresenter);
